export default "__VITE_ASSET__faba71db__"